(ns minorodata.statuses.domain
  "Pure status knowledge, kept out of `events`/`subs` so a view can read it without
   pulling in event registrations.")


(def kind->id-key
  {:extract :extract-id
   :model   :model-id})


(def kind->failed-status
  {:extract "fail"
   :model   "failed"})


(defn extract-status->ui
  [status]
  (case status
    ("success" "succeeded") "completed"
    "fail"                  "failed"
    ("pending" "running")   "pending"
    nil))


(defn newer-run
  "Resolves two rows for the SAME entity: the later `:created-at` wins, and a dated
   row beats an undated one. Which HTTP response landed last is not a fact about
   which run is current, so the store can't be a plain last-write-wins merge."
  [a b]
  (let [ms #(some-> (:created-at %) js/Date. .getTime)
        ta (ms a)
        tb (ms b)]
    (cond
      (nil? tb) a
      (nil? ta) b
      (> ta tb) a
      :else     b)))


(defn index-by-id
  "Rows with no id are dropped: the extracts endpoint left-joins, so a never-run
   extract comes back all-nil."
  [id-key rows]
  (into {}
        (keep (fn [row]
                (when-let [id (get row id-key)]
                  [id row])))
        rows))
